<template>
  <div>
    <el-form class="grammar-type-form" ref="form" label-width="80px">
      <el-form-item label="父级" v-if="form.id">
        <GrammarTypeSelect v-model="form.pid" :type="form"></GrammarTypeSelect>
      </el-form-item>
      <el-form-item label="名称">
        <el-input v-if="form.id" v-model="form.name"></el-input>
        <el-input v-else v-model="form.names" type="textarea" resize="none" :autosize="{minRows:2}" placeholder="一行一个"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import GrammarTypeSelect from './GrammarTypeSelect'
export default {
  name: 'GrammarTypeForm',
  data () {
    return {
      form: {
        id: null,
        pid: null,
        root: null,
        lft: null,
        rgt: null,
        name: '',
        names: '',
        status: 1
      }
    }
  },
  components: {GrammarTypeSelect},
  methods: {
    reset (model) {
      this.form = Object.assign({
        id: null,
        pid: null,
        name: '',
        names: '',
        status: 1
      }, model)
    },
    getFormData () {
      return {
        id: this.form.id,
        pid: this.form.pid,
        name: this.form.name,
        names: this.form.names,
        status: this.form.status
      }
    },
    submit () {
      var params = this.getFormData()
      if (this.form.id) {
        delete params.id
        return this.$http.put(this.$urls.grammar_type_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.grammar_type_create, params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .pinyin-preview{
    margin-left: 80px;
    margin-top: -10px;
    border-top: 1px solid #ddd;
    padding-top: 15px;
  }
</style>
